import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Hosting from "@/pages/Hosting";
import Domains from "@/pages/Domains";
import Servers from "@/pages/Servers";
import Security from "@/pages/Security";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";

function App() {
  return (
    <div className="App dark min-h-screen bg-[#0A0B10] text-white">
      <BrowserRouter>
        <Navbar />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hosting" element={<Hosting />} />
            <Route path="/alan-adi" element={<Domains />} />
            <Route path="/sunucular" element={<Servers />} />
            <Route path="/guvenlik" element={<Security />} />
            <Route path="/fiyatlandirma" element={<Pricing />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/giris" element={<Login />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "rgba(18, 20, 29, 0.95)",
              border: "1px solid rgba(0, 122, 255, 0.3)",
              color: "#fff",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
